import React from 'react';
import { Shirt, Sparkles, BookOpen, Plus, User } from 'lucide-react';

interface BottomNavProps {
  activeTab: 'closet' | 'studio' | 'lookbook';
  setActiveTab: (tab: 'closet' | 'studio' | 'lookbook') => void;
  onOpenAddItem: () => void;
  onOpenBodyProfiles: () => void;
}

export const BottomNav: React.FC<BottomNavProps> = ({
  activeTab,
  setActiveTab,
  onOpenAddItem,
  onOpenBodyProfiles,
}) => {
  return (
    <div className="md:hidden fixed bottom-0 left-0 right-0 z-40 bg-slate-900/90 backdrop-blur-lg border-t border-slate-800 px-3 py-2 flex items-center justify-around shadow-2xl safe-bottom">
      {/* Closet */}
      <button
        onClick={() => setActiveTab('closet')}
        className={`flex flex-col items-center justify-center py-1 px-2 rounded-lg text-xs font-medium transition-colors ${
          activeTab === 'closet' ? 'text-brand-400' : 'text-slate-400 hover:text-slate-200'
        }`}
      >
        <Shirt className="w-5 h-5 mb-1" />
        <span>Closet</span>
      </button>

      {/* AI Try-On Studio */}
      <button
        onClick={() => setActiveTab('studio')}
        className={`flex flex-col items-center justify-center py-1 px-2 rounded-lg text-xs font-medium transition-colors ${
          activeTab === 'studio' ? 'text-brand-400' : 'text-slate-400 hover:text-slate-200'
        }`}
      >
        <Sparkles className="w-5 h-5 mb-1" />
        <span>Try-On</span>
      </button>

      {/* Add Garment FAB Button */}
      <button
        onClick={onOpenAddItem}
        className="flex items-center justify-center w-12 h-12 -mt-5 rounded-full bg-gradient-to-tr from-brand-600 to-indigo-500 text-white shadow-lg shadow-brand-500/40 border-2 border-slate-900 transition-transform active:scale-95"
      >
        <Plus className="w-6 h-6 stroke-[2.5]" />
      </button>

      {/* Lookbook */}
      <button
        onClick={() => setActiveTab('lookbook')}
        className={`flex flex-col items-center justify-center py-1 px-2 rounded-lg text-xs font-medium transition-colors ${
          activeTab === 'lookbook' ? 'text-brand-400' : 'text-slate-400 hover:text-slate-200'
        }`}
      >
        <BookOpen className="w-5 h-5 mb-1" />
        <span>Looks</span>
      </button>

      {/* My Body Profile */}
      <button
        onClick={onOpenBodyProfiles}
        className="flex flex-col items-center justify-center py-1 px-2 rounded-lg text-xs font-medium text-slate-400 hover:text-slate-200 transition-colors"
      >
        <User className="w-5 h-5 mb-1" />
        <span>Me</span>
      </button>
    </div>
  );
};
